import LineClampTooltip from 'components/common/LineClampTooltip';
import React from 'react';
import { I18n } from 'utils/i18n';

const renderPermissionsCell = params => {
  const permissions = params.value || [];
  const names = permissions.map(p => p?.team?.name).filter(Boolean);
  const emptyLabel =
    params.row?.kind === 'DocumentFormat'
      ? I18n.t('ShareDrawer.Everyone')
      : I18n.t('ShareDrawer.CompanyAdminsOnly');
  const text = names.length > 0 ? names.join(', ') : emptyLabel;
  return <LineClampTooltip lines={2}>{text}</LineClampTooltip>;
};

export default renderPermissionsCell;
